/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum ITEM_NAMES {
  plans,
  readyPrint,
  terms,
  policy,
  cookiePolicy,
  cookieSettings,
}

export const MENU_ITEMS = [
  {
    textPath: 'plans',
    name: ITEM_NAMES.plans,
  },
  {
    textPath: 'readyPrint',
    name: ITEM_NAMES.readyPrint,
    linkPath: 'links.readyPrint',
  },
  {
    textPath: 'terms',
    name: ITEM_NAMES.terms,
    linkPath: 'links.terms',
  },
  {
    textPath: 'policy',
    name: ITEM_NAMES.policy,
    linkPath: 'links.privacy',
  },
  {
    textPath: 'cookiePolicy',
    name: ITEM_NAMES.cookiePolicy,
    linkPath: 'links.cookiePolicy',
  },
  {
    textPath: 'cookieSettings',
    name: ITEM_NAMES.cookieSettings,
    action: 'OneTrust.ToggleInfoDisplay'
  },
]
